module.exports = __webpack_public_path__ + "img/services.ceea64a6.jpg";